var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "ActionsLicencesModal p-3 w-100" },
    [
      _c("div", {
        staticClass: "my-2",
        domProps: {
          innerHTML: _vm._s(
            _vm.$tc(
              "device.registrations." + _vm.type + "_licences.count",
              _vm.itemCount,
              { count: _vm.itemCount }
            )
          ),
        },
      }),
      _vm._v(" "),
      _c("div", {
        staticClass: "my-3",
        domProps: {
          innerHTML: _vm._s(
            _vm.$t("device.registrations." + _vm.type + "_licences.info")
          ),
        },
      }),
      _vm._v(" "),
      _c(
        "Button2",
        {
          staticClass: "btn-sm my-2",
          attrs: { disabled: _vm.loading || _vm.licences !== undefined },
          nativeOn: {
            click: function ($event) {
              $event.preventDefault()
              return _vm.loadDetails($event)
            },
          },
        },
        [
          _vm._v(
            "\n        " +
              _vm._s(_vm.$t("device.registrations.details_modal.get_details")) +
              "\n        "
          ),
          _vm.loading
            ? _c(
                "div",
                {
                  staticClass: "spinner-border spinner-border-sm ml-2",
                  attrs: { role: "status" },
                },
                [
                  _c("span", { staticClass: "sr-only" }, [
                    _vm._v(_vm._s(_vm.$t("global.loading"))),
                  ]),
                ]
              )
            : _vm._e(),
        ]
      ),
      _vm._v(" "),
      _vm.licences !== undefined
        ? _c(
            "div",
            [
              _c("SuperTable", {
                attrs: {
                  tableColumns: _vm.tableColumns,
                  tableData: _vm.licences,
                  loading: _vm.loading,
                },
              }),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }